import { render, staticRenderFns } from "./right-box.vue?vue&type=template&id=10b84f48&scoped=true"
import script from "./right-box.vue?vue&type=script&lang=js"
export * from "./right-box.vue?vue&type=script&lang=js"
import style0 from "./right-box.vue?vue&type=style&index=0&id=10b84f48&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10b84f48",
  null
  
)

export default component.exports